import { useEffect, useMemo, useState  } from "react";
import { useNavigate } from "react-router-dom";
import { useGetASNListMutation, useGetAllPurchaseOrdersForASNQuery } from '../../../../store/api/asnApi';
import ActionButtonDropdown from "../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../Core/Layout/ListLayout";
import Table from "../../../../Core/Table/Table";
import Tabs from "../../../../Components/Tabs";
import ConfigureColumnsNew from "../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ExportCSV from '../../../../Core/Export/ExportCSV';
import ListFilters from "../../../../Core/ListFilters/ListFilters";
import {
    usePostSupplierListMutation,
    useTotalSupplierCountMutation,
} from "../../../../store/api/itemapi";
import { useDeleteDocMutation } from "../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../utils/useScreenHeight";
import { Helmet } from "react-helmet";

const Lpntable = () => {
    const navigate = useNavigate();
	const { screenHeight, screenScaling , pageSize} = useScreenHeight();
    const [filters, setFilters] = useState({});
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [showColumnConfig, setShowColumnConfig] = useState(false);
    const [showExportPopup, setShowExportPopup] = useState(false);
    const [showFilters, setShowFilters] = useState(false);
    const [purchaseData, setPurchaseData] = useState({ shipment_data: [], total_no_of_records: 0 });
    const [trigger] = useGetASNListMutation();

    // Supplier and PO data
    const [postSupplierList] = usePostSupplierListMutation();
    const [totalSupplierCount] = useTotalSupplierCountMutation();
    const [supplierData, setSupplierData] = useState(null);
    const { data: PurchaseOrders } = useGetAllPurchaseOrdersForASNQuery();
    const supplierOptions = supplierData?.data?.map(item => ({
        value: item.supplier_name,
        label: item.supplier_name
    })) || [];
    const purchaseOrderOptions = PurchaseOrders?.message?.map(item => ({
        value: item,
        label: item
    })) || [];

    //States for deleted records
    const [deleteDoc] = useDeleteDocMutation();
	const [delPopupVisible, setDelPopupVisible] = useState(false);
	const [delSelectedId, setDelSelectedId] = useState(null);
	const [delmessage, setDelmessage] = useState();
	const [alreadySubmitData, setAlreadySubmitData] = useState(false);
	const [delDone, setDelDone] = useState(false);
    const ExpandableCell = ({ values }) => {
        const [expanded, setExpanded] = useState(false);

        if (!values || values.length === 0) return <span>-</span>;

        const displayedValues = expanded ? values : values.slice(0, 0);
        const hiddenCount = values.length - displayedValues.length;

        return (
            <div
                onClick={() => setExpanded(!expanded)}
                title={values.join(', ')}
                style={{
                    cursor: 'pointer',
                    display: 'flex',
                    flexWrap: 'wrap',
                    gap: '5px',
                    fontSize: '13px',
                    alignItems: 'center',
                }}
            >
                {displayedValues.map((val, idx) => (
                    <span
                        key={idx}
                        style={{
                            backgroundColor: '#e0e0e0',
                            padding: '2px 8px',
                            borderRadius: '999px',
                        }}
                    >
                        {val}
                    </span>
                ))}

                {!expanded && hiddenCount > 0 && (
                    <span
                        style={{
                            backgroundColor: '#d0d0ff',
                            padding: '2px 8px',
                            borderRadius: '999px',
                        }}
                    >
                        +{hiddenCount} more
                    </span>
                )}
            </div>
        );
    };

    const [columnsConfig, setColumnsConfig] = useState(() => [
        {
            header: "S. No.",
            name: "S. No.",
            accessor: "siNo",
            width: '7%',
            cellRenderer: (row) => row.siNo,
            sortable: false,
            visible: true
        },
        {
            header: "Asn Id",
            name: "Asn Id",
            accessor: "name",
            width: '12%',
            sortable: true,
            visible: true
        },
        {
            header: "Supplier",
            name: "Supplier",
            accessor: "supplier",
            width: '12%',
            sortable: true,
            visible: true
        },
        {
            header: "Posting Date",
            name: "Posting Date",
            accessor: "posting_date",
            width: '12%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => new Date(a.posting_date) - new Date(b.posting_date)
        },
        {
            header: "Estimated Arrival",
            name: "Estimated Arrival",
            accessor: "estimated_arrival",
            width: '13%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => new Date(a.estimated_arrival) - new Date(b.estimated_arrival)
        },
        {
            header: "Modified Date",
            name: "Modified Date",
            accessor: "modified",
            width: '14%',
            sortable: true,
            visible: true,
            sortFn: (a, b) => new Date(a.modified) - new Date(b.modified)
        },
        {
            header: "Purchase Orders",
            name: "Purchase Orders",
            accessor: "purchase_orders",
            width: '14%',
            sortable: false,
            visible: true,
            cellRenderer: (row) => <ExpandableCell values={row.purchase_orders} />
        },
        {
            header: "Status",
            name: "Status",
            accessor: "status",
            width: '10.7%',
            sortable: false,
            visible: true,
            cellRenderer: (row) => {
                let statusLabel = '';
                let color = '';

                switch (row.docstatus) {
                    case 0:
                        statusLabel = 'Draft';
                        color = '#6366F1';
                        break;
                    case 1:
                        statusLabel = 'Submitted';
                        color = '#65A30D';
                        break;
                    case 2:
                        statusLabel = 'Cancelled';
                        color = '#EF4444';
                        break;
                    default:
                        statusLabel = 'Unknown';
                        color = '#000000';
                }

                return <span style={{
                    backgroundColor: `${color}1A`,
                    color,
                    padding: '4px 10px',
                    borderRadius: '9999px',
                    fontSize: '12px',
                    fontWeight: 500,
                    display: 'inline-block',
                    textTransform: 'capitalize',
                }}>{statusLabel}</span>;
            }
        },
        {
            header: "Action",
            name: "Action",
            width: '10%',
            sortable: false,
            accessor: "action",
            visible: true,
            cellRenderer: (row) => (
                <ActionButtonDropdown
                    id={row.name}
                    onView={() => handleView(row.name)}
                    onEdit={() => handleEdit(row.name)}
                    onDelete={() => handleDelete(row.name)}
                />
            )
        },
    ]);


    const filtersConfig = [
        {
            name: 'name',
            label: 'ASN ID',
            width: '13%',
            type: 'text'
        },
        {
            name: 'supplier',
            label: 'Supplier',
            width: '13%',
            type: 'select',
            options: supplierOptions
        },
        {
            name: 'posting_date_range',
            label: 'Posting Date',
            type: 'date-range',
            width: '16%'
        },
        {
            name: 'estimated_arrival_range',
            label: 'Estimated Arrival',
            type: 'date-range',
            width: '16%'
        },
        {
            name: 'docstatus',
            label: 'Status',
            width: '10.7%',
            type: 'select',
            options: [
                { value: 0, label: 'Draft' },
                { value: 1, label: 'Submitted' },
                { value: 2, label: 'Cancelled' }
            ]
        },
        {
            name: 'purchase_orders',
            label: 'Purchase Orders',
            type: 'selectsearch',
            width: '15%',
            options: purchaseOrderOptions,
            multiSelect: true
        }
    ];


    // Handle column configuration changes
    const handleSaveColumns = (selectedKeys, allFields) => {
        const updatedColumns = columnsConfig.map(column => {
            return {
                ...column,
                visible: selectedKeys.includes(column.accessor)
            };
        });
        setColumnsConfig(updatedColumns);
    };

    const visibleColumns = useMemo(() =>
        columnsConfig.filter(col => col.visible === true),
        [columnsConfig]
    );

    const defaultSelectedColumns = useMemo(() =>
        columnsConfig
            .filter(col => col.visible === true)
            .map(col => ({
                fieldname: col.accessor,
                label: col.name
            }))
            .filter(col => col.fieldname),
        [columnsConfig]
    );

    useEffect(() => {
        const fetchSuppliers = async () => {
            try {
                const countRes = await totalSupplierCount().unwrap();
                const totalCount = countRes.message;

                const supplierRes = await postSupplierList({
                    start: 0,
                    limit: totalCount,
                    filters: [],
                    fields: [],
                }).unwrap();

                setSupplierData(supplierRes);
            } catch (err) {
                console.error("Error fetching suppliers", err);
            }
        };

        fetchSuppliers();
    }, []);



    const handleFilterChange = (newFilters) => {
        setCurrentPage(1);
        setFilters(newFilters);
    };

    const handleView = (id) => {
        try {
            navigate(`/inbound/asn/view/`, { state: { asn_id: id } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };

    const handleEdit = async (id) => {
        try {
            navigate(`/inbound/asn/edit/`, { state: { asn_id: id } });
        } catch (err) {
            console.error("Edit failed:", err);
        }
    };

    const handleDelete = (id) => {
        setDelSelectedId(id);
        setDelPopupVisible(true);
        setAlreadySubmitData(false);
        setDelmessage("Are you sure you want to Delete this ASN?");
    };

    const delHandleCancel = () => {
        setDelPopupVisible(false);
        setDelSelectedId(null);
    };

    const delHandleConfirm = async () => {
        try {
            await deleteDoc({
							doctype: "Advance Shipment Note",
							name: delSelectedId,
						}).unwrap();
            setDelmessage(`ASN ${delSelectedId} deleted successfully!`);
            setDelDone(true);
            setTimeout(() => {
                setDelPopupVisible(false);
                setDelSelectedId(null);
                setDelDone(false);
                fetchData();
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err);

            let errorMessage = "Failed to delete the ASN!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages);
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0]);
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message;
                            errorMessage = fullMessage.trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, "");
                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true);
            setDelmessage(errorMessage);
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };
    const activeFilterCount = useMemo(() => {
        return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
    }, [filters]);
    const actionButtons = [
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "IoFilterSharp",
            iconSize: 12,
            children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
            onClick: () => {
                setShowFilters(prev => !prev);
                setShowColumnConfig(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "MdOutlineRemoveRedEye",
            iconSize: 12,
            children: "Show more",
            onClick: () => {
                setShowColumnConfig(prev => !prev);
                setShowFilters(false);
            }
        },
        {
            className: "createbtn border-0 d-flex",
            style: { gap: '2px', height: '28px' },
            iconName: "RiFileExcel2Fill",
            iconSize: 12,
            children: "Export Excel",
            onClick: () => setShowExportPopup(true),
        },
        {
            className: "custom-btn-00989 d-flex",
            to: "/inbound/asn/createasn",
            iconName: "FiPlus",
            style: { gap: '2px', height: '28px' },
            children: "Add Asn"
        }
    ];

    const fetchData = async () => {
			setLoading(true);
			try {
				const filteredSearchInput = Object.entries(filters).reduce(
					(acc, [key, value]) => {
						if (value !== "" && value !== undefined && value !== null) {
							acc[key] = value;
						}
						return acc;
					},
					{}
				);
				const siNoFilter = filteredSearchInput.siNo;
				const isSiNoFilterActive =
					siNoFilter !== undefined && siNoFilter !== "";
				// STEP 3: If filtering by siNo, jump to that page
				const targetPage = isSiNoFilterActive
					? Math.ceil(parseInt(siNoFilter, 10) / pageSize)
					: currentPage;
				const payload = {
					start: pageSize * (targetPage - 1),
					limit: pageSize,
					...(Object.keys(filteredSearchInput).length > 0 && {
						...filteredSearchInput,
						docstatus: filteredSearchInput?.docstatus
							? parseInt(filteredSearchInput.docstatus)
							: undefined,
					}),
				};

				const res = await trigger(payload).unwrap();
				const rawData = res.data.asn_list;
				// STEP 4: Assign global serial numbers
				const numberedData = rawData.map((item, index) => ({
					...item,
					siNo: index + 1 + pageSize * (targetPage - 1),
				}));

				// STEP 5: If siNo is used, filter client-side
				const finalData = isSiNoFilterActive
					? numberedData.filter(
							(item) => item.siNo === parseInt(siNoFilter, 10)
					  )
					: numberedData;
				setPurchaseData({
					shipment_data: finalData || [],
					total_no_of_records: res.data.total_count || 0,
				}); // Optional: update currentPage to reflect jump
				if (isSiNoFilterActive) setCurrentPage(targetPage);
			} catch (err) {
				console.error("Error fetching shipment list:", err);
			} finally {
				setLoading(false);
			}
		};
    useEffect(() => {
        if( pageSize > 0)
            fetchData();
    }, [currentPage, filters, trigger,pageSize,screenHeight,screenScaling]);

    const accessors = columnsConfig
			.filter(
				(column) => column.accessor !== "siNo" && column.accessor !== "action"
			)
			.map((column) => column.accessor);
    return (
			<div
				className="container-fluid d-flex flex-column"
				style={{ flexGrow: "1" }}
        >
            <Helmet>
                <title>ASN List</title>
                </Helmet>
				<Tabs />
				<ListLayout
					breadcrumbItems={[
						{ label: "Inbound" },
						{ label: "Asn List", style: { color: "#270B79" } },
					]}
					actionButtons={actionButtons}
				>
					{showFilters && (
						<ListFilters
							filtersConfig={filtersConfig}
							onFilterChange={handleFilterChange}
							currentFilters={filters}
							setShowFilters={setShowFilters}
						/>
					)}

				{showColumnConfig && (
						<ConfigureColumnsNew
							show={showColumnConfig}
							onClose={() => setShowColumnConfig(false)}
							onSave={handleSaveColumns}
							docType="Advance Shipment Note"
							defaultSelected={defaultSelectedColumns}
							fieldsData={columnsConfig.map((col) => ({
								fieldname: col.accessor,
								label: col.name,
							}))}
							disabledFields={["siNo", "status", "action","name"]}
						/>
					)}

				<Table
					columns={visibleColumns}
					data={purchaseData.shipment_data}
					loading={loading}
				/>

				<Pagination
					setCurrentPage={setCurrentPage}
					pageSize={pageSize}
					totalRecords={purchaseData.total_no_of_records}
					currentPage={currentPage}
					className="mt-2 pb-3"
				/>
				{delPopupVisible && (
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
				)}
				{showExportPopup && (
					<ExportCSV
                        doctype="Advance Shipment Note"
                        fieldsData={accessors}
						onClose={() => setShowExportPopup(false)} />
	            )}
	        </ListLayout>
        </div>
    );
};

export default Lpntable;